<div class="d-inline-flex">
  <ncp-button
    #addDiagnosticTestButton
    [options]="btnDTOptions()"
  >
    @if(dtLoading) {
      <div class="loading spinner-border text-light" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    } @else {
      <img
        [ngSrc]="assets.healthIcons.svg.outline.symbols.diagnostics.src"
        width="18"
        height="18"
        alt="Add Diagnostic Test"
        class="healthIcon"
      />
    }
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="diagnostic_tests_form"
      name="diagnostic_tests_form"
      [formGroup]="form"
      #dtFrm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-dropdown #bloodTypesDesc [(options)]="bloodTypesDescDDOptions" />
      <ncp-date #testDate [(options)]="testDateOptions" />
    </form>
  </ncp-modal>
</div>
